import React from 'react';

function Home() {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-xl font-semibold mb-4">Welcome</h1>
      <p className="mb-4">This is the starter home page.</p>
      <a href="/profile" className="text-blue-600 underline">View Profile</a>
    </div>
  );
}

export default Home;
